import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BrowserUtils } from '@azure/msal-browser';
import { FailedComponent } from './failed/failed.component';
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import { LoginComponent } from './modules/login/login.component';
import { ReportsComponent } from './modules/reports/reports.component';
import { MsalGuard } from '@azure/msal-angular';
import { LoginGuard } from './shared/guards/login.guard';
import { AdminGuard } from './shared/guards/admin.guard';

const routes: Routes = [
    {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [LoginGuard, MsalGuard],
    },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
    },
    {
        path: 'login',
        component: LoginComponent,
    },
    {
        path: 'bills',
        loadChildren: () =>
            import('./modules/bills/bills.module').then((m) => m.BillsModule),
    },
    {
        path: 'lists',
        loadChildren: () =>
            import('./modules/lists/lists.module').then((m) => m.ListsModule),
    },
    {
        path: 'requests',
        loadChildren: () =>
            import('./modules/requests/requests.module').then(
                (m) => m.RequestsModule,
            ),
    },
    {
        path: 'users',
        loadChildren: () =>
            import('./modules/users/users.module').then((m) => m.UsersModule),
    },
    {
        path: 'admin',
        canActivate: [LoginGuard, AdminGuard, MsalGuard],
        loadChildren: () =>
            import('./modules/admin/admin.module').then((m) => m.AdminModule),
    },
    {
        path: 'reports',
        canActivate: [LoginGuard, MsalGuard],
        loadChildren: () =>
            import('./modules/reports/reports.module').then(
                (m) => m.ReportsModule,
            ),
    },
    {
        path: 'login-failed',
        component: FailedComponent,
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            // Don't perform initial navigation in iframes or popups
            initialNavigation:
                !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup()
                    ? 'enabledNonBlocking'
                    : 'disabled', // Remove this line to use Angular Universal
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
